import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { GalleryItem } from '../types'

interface DeleteConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  item?: GalleryItem | null
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  item,
}) => {
  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div
        className={`bg-white rounded-[40px] shadow-[0px_4px_20px_0px_rgba(0,0,0,0.25)] ${
          isMobile ? 'mx-4 w-[335px]' : 'w-[335px]'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 상단 콘텐츠 영역 */}
        <div className="flex flex-col justify-center items-center gap-6 px-5 py-8">
          {/* 제목 */}
          <h2 className="text-[#222222] text-[18px] font-bold leading-[1.44] text-center">
            항목 삭제
          </h2>

          {/* 메시지 */}
          <div className="text-[#5E6068] text-[14px] font-normal leading-[1.57] text-center w-full">
            <span className="text-main font-bold">
              선택된 항목을 삭제하시겠어요?
            </span>
            <br />
            삭제된 항목은 되돌릴 수 없습니다.
          </div>
        </div>

        {/* 하단 버튼 영역 */}
        <div className="flex ">
          {/* 취소 버튼 */}
          <button
            onClick={onClose}
            className="flex-1 bg-[#EEF1F7] text-[#5E6068] text-[14px] font-bold leading-[1.57] py-[19px] px-[10px] text-center rounded-bl-[40px] hover:bg-[#E5E8EE] transition-colors"
          >
            취소
          </button>

          {/* 삭제 버튼 */}
          <button
            onClick={handleConfirm}
            className="flex-1 bg-[#00B7B9] text-white text-[14px] font-bold leading-[1.57] py-[19px] px-[10px] text-center rounded-br-[40px] hover:bg-[#00A5A7] transition-colors"
          >
            삭제
          </button>
        </div>
      </div>
    </div>
  )
}
